/* =========================
   VERSION 1 : PREDICTION (Dropdown personnalisé)
   ========================= */
function registerAutocompletePrediction(input, callback) {
    if ($(input).hasClass('autocompleteaddressdivdone')) return;
    $(input).addClass('autocompleteaddressdivdone');

    const resultsBox = $('#autocomplete-results');
    const service = new google.maps.places.AutocompleteService();
    const placesService = new google.maps.places.PlacesService(document.createElement('div'));
    let predictions = [];
    let activeIndex = -1;
    let sessionToken = new google.maps.places.AutocompleteSessionToken();

    function getTypeLabel(types) {
        if (types.includes('sublocality_level_1')) return 'Arrondissement';
        if (types.includes('postal_code')) return 'Code postal';
        if (types.includes('locality')) return 'Ville';
        if (types.includes('administrative_area_level_2')) return 'Département';
        if (types.includes('administrative_area_level_1')) return 'Région';
        return 'Lieu';
    }

    function renderResults() {
        if (!predictions || predictions.length === 0) {
            resultsBox.html(`
                <div class="autocomplete-item no-result">
                    <strong>Aucun lieu correspondant</strong>
                    <div style="font-size:12px; color:#666;">
                        Nous n'avons pas pu trouver de lieu correspondant à votre recherche.<br>
                        Veuillez vérifier l'orthographe ou essayez de rechercher un autre lieu ou code postal.
                    </div>
                </div>
            `).show();
            return;
        }

        resultsBox.html(
            predictions.map((p, i) => `
                <div class="autocomplete-item ${i === activeIndex ? 'active' : ''}" data-index="${i}">
                    <span>${p.description}</span>
                    <span class="autocomplete-type">${getTypeLabel(p.types)}</span>
                </div>
            `).join('')
        ).show();
    }

    function selectPrediction(index) {
        const p = predictions[index];
        if (!p) return;

        placesService.getDetails({ placeId: p.place_id }, place => {
            if (!place || !place.geometry) return;

            const comp = type => place.address_components?.find(c => c.types.includes(type))?.long_name || null;

            const data = {
                address: [comp('street_number'), comp('route')].filter(Boolean).join(' ') || null,
                cp: comp('postal_code'),
                city: comp('locality') || comp('postal_town'),
                region: comp('administrative_area_level_1'),
                country: comp('country'),
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };

            callback(data);
        });

        resultsBox.hide();
        $(input).val(p.description);
    }

    $(input).on('input', function () {
        const value = this.value.trim();
        activeIndex = -1;
        if (!value) { resultsBox.hide(); return; }

        service.getPlacePredictions({
            input: value,
            types: ['(regions)'],
            // componentRestrictions: { country: 'fr' },
            sessionToken
        }, (res, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK) {
                predictions = [];
                renderResults();
                return;
            }
            predictions = res;
            renderResults();
        });
    });

    $(document).on('click', '.autocomplete-item', function () {
        if ($(this).hasClass('no-result')) {
            $(input).val('');
            resultsBox.hide();
        } else {
            selectPrediction(parseInt($(this).data('index')));
        }
    });

    $(input).on('keydown', function (e) {
        if (!predictions || !predictions.length) return;

        if (e.key === 'ArrowDown') { e.preventDefault(); activeIndex = (activeIndex + 1) % predictions.length; renderResults(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); activeIndex = activeIndex <= 0 ? predictions.length - 1 : activeIndex - 1; renderResults(); }
        if (e.key === 'Enter') { e.preventDefault(); if (activeIndex >= 0) selectPrediction(activeIndex); }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.autocomplete-wrapper').length) resultsBox.hide();
    });
}

/* =========================
   VERSION 2 : GOOGLE AUTOCOMPLETE (champs cachés)
   ========================= */
function registerAutocompleteGoogle(input, callback) {
    if ($(input).hasClass('autocompleteaddressdivdone')) return;
    $(input).addClass('autocompleteaddressdivdone');

    const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        // componentRestrictions: { country: 'fr' }
    });

    autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();
        if (!place || !place.geometry) return;

        const comp = type => place.address_components?.find(c => c.types.includes(type))?.long_name || null;

        const data = {
            address: [comp('street_number'), comp('route')].filter(Boolean).join(' ') || null,
            cp: comp('postal_code'),
            city: comp('locality') || comp('postal_town'),
            region: comp('administrative_area_level_1'),
            country: comp('country'),
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        };

        callback(data);
    });
}

/* =========================
   INIT AUTOCOMPLETE POUR TOUS LES CHAMPS
   ========================= */
function initAutocompleteaddress() {

    // =====================
    // Input principal : recherche
    // =====================
    $('#autocomplete-input').each(function () {
        registerAutocompletePrediction(this, function (data) {
            var s = [];
            $('.categories input:checked').each(function () { s.push($(this).attr('name') + '=1'); });
            if (parseInt($('.range-output').html())) s.push('distance=' + parseInt($('.range-output').html()));
            s.push('lat=' + data.lat);
            s.push('lng=' + data.lng);
            s.push('address=' + ((data.address || '') + ' ' + (data.cp || '') + ' ' + (data.city || '')).trim());
            window.location.href = '/fr/search?' + s.join('&');
        });
    });

    // =====================
    // Formulaire avec champs cachés
    // =====================
    $('.autocompleteaddressdiv').each(function () {
        var self = this;
        if (!$(self).is(':visible')) return;
        if ($(self).find('.autocompleteaddress').length) return;

        var label = $(self).find('.control-label').eq(0).html();
        var input = $('<input type="text" class="autocompleteaddress" autocomplete="false" />');
        input.prop('required', $(self).find('.address').prop('required'));

        const address = $(self).find('.address').val();
        const cp = $(self).find('.cp').val();
        const city = $(self).find('.city').val();
        const country = $(self).find('.country').val();

        if (address && cp && city) {
            input.val(address + ', ' + cp + ' ' + city + (country ? ', ' + country : ''));
        }

        $(self).prepend('<p class="messagealert" style="display:none"></p>');
        var wrapper = $(`
            <div class="" for="address">
                <label class="control-label">${label}</label>
                <div></div>
            </div>
        `);
        wrapper.find('div').append(input);
        $(self).prepend(wrapper);

        // Masquer les champs existants
        $(self).find('.address, .cp, .city, .country, .lat, .lng, .inseeCode').closest('[for]').hide();

        // Register Google autocomplete (remplissage automatique des champs)
        registerAutocompleteGoogle($(self).find('.autocompleteaddress')[0], function (data) {
            if (!data.address || !data.cp) return;

            (async (url) => {
                try {
                    if ($(self).find('.inseeCode').length) {
                        const response = await fetch(url);
                        if (response.ok) {
                            const result = await response.json();
                            if (result.inseeCode) data.inseeCode = result.inseeCode;
                        }
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    $(self).find('.lat').val(data.lat || '');
                    $(self).find('.lng').val(data.lng || '');
                    $(self).find('.address').val(data.address || '');
                    $(self).find('.cp').val(data.cp || '');
                    $(self).find('.city').val(data.city || '');
                    $(self).find('.country').val(data.country || '');
                    $(self).find('.inseeCode').val(data.inseeCode || '');
                    // createMap(data.lat, data.lng);
                    autocompleteHideError(self);
                }
                document.dispatchEvent(new CustomEvent('registerAutocompleteEnd'));
            })(`/fr/property/inseeCode?cp=${data.cp}&city=${data.city}`);
        });
    });
}


// function registerAutocomplete(input, callback) {
//     if ($(input).hasClass('autocompleteaddressdivdone')) return;
//     $(input).addClass('autocompleteaddressdivdone');

//     const resultsBox = $('#autocomplete-results');
//     const service = new google.maps.places.AutocompleteService();
//     const placesService = new google.maps.places.PlacesService(document.createElement('div'));

//     let predictions = [];
//     let activeIndex = -1;
//     let sessionToken = new google.maps.places.AutocompleteSessionToken();

//     function getTypeLabel(types) {
//         if (types.includes('sublocality_level_1')) return 'Arrondissement';
//         if (types.includes('postal_code')) return 'Code postal';
//         if (types.includes('locality')) return 'Ville';
//         if (types.includes('administrative_area_level_2')) return 'Département';
//         if (types.includes('administrative_area_level_1')) return 'Région';
//         return 'Lieu';
//     }

//     function renderResults() {
//         if (!predictions || predictions.length === 0) {
//             resultsBox.html(`
//                 <div class="autocomplete-item no-result">
//                     <strong>Aucun lieu correspondant</strong>
//                     <div style="font-size:12px; color:#666;">
//                         Nous n'avons pas pu trouver de lieu correspondant à votre recherche.<br>
//                         Veuillez vérifier l'orthographe ou essayez de rechercher un autre lieu ou code postal.
//                     </div>
//                 </div>
//             `).show();
//             return;
//         }

//         resultsBox.html(
//             predictions.map((p, i) => `
//                 <div class="autocomplete-item ${i === activeIndex ? 'active' : ''}" data-index="${i}">
//                     <span>${p.description}</span>
//                     <span class="autocomplete-type">${getTypeLabel(p.types)}</span>
//                 </div>
//             `).join('')
//         ).show();
//     }

//     function selectPrediction(index) {
//         const p = predictions[index];
//         if (!p) return;

//         placesService.getDetails({ placeId: p.place_id }, place => {
//             if (!place || !place.geometry) return;

//             const comp = type =>
//                 place.address_components?.find(c => c.types.includes(type))?.long_name || null;

//             const data = {
//                 address: [comp('street_number'), comp('route')].filter(Boolean).join(' ') || null,
//                 cp: comp('postal_code'),
//                 city: comp('locality') || comp('postal_town'),
//                 region: comp('administrative_area_level_1'),
//                 country: comp('country'),
//                 lat: place.geometry.location.lat(),
//                 lng: place.geometry.location.lng(),
//             };

//             callback(data);
//         });

//         resultsBox.hide();
//         $(input).val(p.description);
//     }

//     $(input).on('input', function () {
//         const value = this.value.trim();
//         activeIndex = -1;

//         if (!value) {
//             resultsBox.hide();
//             return;
//         }

//         service.getPlacePredictions({
//             input: value,
//             types: ['(regions)'],
//             componentRestrictions: { country: 'fr' },
//             sessionToken
//         }, (res, status) => {
//             if (status !== google.maps.places.PlacesServiceStatus.OK) {
//                 renderResults();
//                 // return;
//             }
//             predictions = res;
//             renderResults();
//         });
//     });

//     $(document).on('click', '.autocomplete-item', function () {
//         if ($(this).hasClass('no-result')) {
//             $(input).val(''); // vide l'input
//             $('#autocomplete-results').hide(); // cache la liste
//         } else {
//             selectPrediction(parseInt($(this).data('index')));
//         }
//     });

//     $(input).on('keydown', function (e) {
//         if (!predictions || !predictions.length) return;

//         if (e.key === 'ArrowDown') {
//             e.preventDefault();
//             activeIndex = (activeIndex + 1) % predictions.length;
//             renderResults();
//         }

//         if (e.key === 'ArrowUp') {
//             e.preventDefault();
//             activeIndex = activeIndex <= 0 ? predictions.length - 1 : activeIndex - 1;
//             renderResults();
//         }

//         if (e.key === 'Enter') {
//             e.preventDefault();
//             if (activeIndex >= 0) selectPrediction(activeIndex);
//         }
//     });

//     $(document).on('click', function (e) {
//         if (!$(e.target).closest('.autocomplete-wrapper').length) {
//             resultsBox.hide();
//         }
//     });
// }


// // function registerAutocomplete(div, callback) {
// //     if ($(div).hasClass('autocompleteaddressdivdone')) return;
// //     $(div).addClass('autocompleteaddressdivdone');

// //     // var autocompletemap = new google.maps.places.Autocomplete(div, { types: ['geocode'] });
// //     var autocompletemap = new google.maps.places.Autocomplete(div, {
// //         types: ['(regions)'],
// //         componentRestrictions: { country: 'fr' }
// //     });

// //     autocompletemap.addListener('place_changed', async function () {
// //         var place = autocompletemap.getPlace();
// //         // console.log('google said', place);

// //         var streetnumber = place.address_components.filter(x => x.types[0] == 'street_number');
// //         var route = place.address_components.filter(x => x.types[0] == 'route');
// //         var locality = place.address_components.filter(x => x.types[0] == 'locality');
// //         var postal_town = place.address_components.filter(x => x.types[0] == 'postal_town');
// //         var administrative_area_level_1 = place.address_components.filter(x => x.types[0] == 'administrative_area_level_1');
// //         var country = place.address_components.filter(x => x.types[0] == 'country');
// //         var postal_code = place.address_components.filter(x => x.types[0] == 'postal_code');

// //         var streetnumber = (streetnumber.length ? streetnumber[0].long_name : null)
// //         var route = (route.length ? route[0].long_name : null);

// //         var address = ((streetnumber || '') + ' ' + (route || '')).trim();
// //         var data = {
// //             address: address == '' ? null : address,
// //             cp: postal_code.length ? postal_code[0].long_name : null,
// //             city: locality[0]?.long_name||postal_town[0]?.long_name,
// //             region: administrative_area_level_1.length ? administrative_area_level_1[0].long_name : null,
// //             country: country.length ? country[0].long_name : null,
// //             lat: place.geometry.location.lat(),
// //             lng: place.geometry.location.lng(),
// //         };

// //         if (data.lat && data.lng) return callback(data);
// //         else console.log('incomplete geocoding', data);
// //     });
// // }

// function initAutocompleteaddress() {
//     $('#autocomplete-input').each(function () {
//         registerAutocomplete(this, function (data) {
//             var s = [];
//             $('.categories input:checked').each(function () {
//                 s.push($(this).attr('name') + '=1')
//             });
//             if (parseInt($('.range-output').html())) s.push('distance=' + parseInt($('.range-output').html()));
//             s.push('lat=' + data.lat);
//             s.push('lng=' + data.lng);
//             s.push('address=' + ((data.address || '') + ' ' + (data.cp || '') + ' ' + (data.city || '')).trim());

//             // umami.trackEvent('home_locataire_searchAddressInput', 'click');
//             window.location.href = '/fr/search?' + s.join('&');
//         })
//     })

//     $('.autocompleteaddressdiv').each(function () {
//         var self = this;
//         if (!$(this).is(':visible')) return;
//         if ($(self).find('.autocompleteaddress').length) return;

//         var label = $(self).find('.control-label').eq(0).html()
//         var input = $('<input type="text" class="autocompleteaddress" autocomplete="false" />');
//         input.prop('required', $(this).find('.address').prop('required'));
//         input.val($(this).find('.address').val() + ' ' + $(this).find('.cp').val() + ' ' + $(this).find('.city').val() + ' ' + $(this).find('.country').val());
//         $(this).prepend('<p class="messagealert" style="display:none"></p>');
//         var shit = $(`
//             <div class="" for="address">
//                 <label class="control-label">
//                     ${label}
//                 </label>
//                 <div>

//                 </div>
//             </div>
//         `);
//         shit.find('label').next().append(input);
//         $(this).prepend(shit);

//         $(this).find('.address').closest('[for]').hide();
//         $(this).find('.cp').closest('[for]').hide();
//         $(this).find('.city').closest('[for]').hide();
//         $(this).find('.country').closest('[for]').hide();
//         $(this).find('.lat').closest('[for]').hide();
//         $(this).find('.lng').closest('[for]').hide();
//         $(this).find('.inseeCode').closest('[for]').hide();

//         registerAutocomplete($(self).find('.autocompleteaddress')[0], function (data) {
//             if (!data.address || !data.cp) return;

//             (async (url) => {
//                 try {
//                     if ($(self).find('.inseeCode').length) {
//                         const response = await fetch(url);
//                         if (response.ok) {
//                             const result = await response.json();
//                             if (result.inseeCode) data.inseeCode = result.inseeCode;
//                         }
//                     }
//                 } catch (err) {
//                     console.error(err);
//                 } finally {
//                     $(self).find('.lat').val(data.lat || '');
//                     $(self).find('.lng').val(data.lng || '');
//                     $(self).find('.address').val(data.address || '');
//                     $(self).find('.cp').val(data.cp || '');
//                     $(self).find('.city').val(data.city || '');
//                     $(self).find('.country').val(data.country || '');
//                     $(self).find('.inseeCode').val(data.inseeCode || '');

//                     createMap(data.lat, data.lng);
//                     autocompleteHideError(self);
//                 }

//                 const event = new CustomEvent('registerAutocompleteEnd');
//                 document.dispatchEvent(event);
//             })(`/fr/property/inseeCode?cp=${data.cp}&city=${data.city}`);
//         });
//     });
// }

// function createMap(lat, lng) {
//     if ($('#map').length == 0) return;
//     console.log('create Map', lat, lng);

//     var gps = { lat: lat, lng: lng };
//     var map = new google.maps.Map(document.getElementById('map'), {
//         zoom: 15,
//         center: gps
//     });
//     var marker = new google.maps.Marker({
//         position: gps,
//         map: map
//     });
//     $('#map').height(490);
// }

// $(document).on('click', '.autocompletemanuel', function () {
//     $(this).closest('.autocompleteaddressdiv').find('.autocompleteaddress').closest('[for]').hide();
//     $(this).closest('.autocompleteaddressdiv').find('.messagealert').hide();
//     $(this).closest('.autocompleteaddressdiv').find('.address').closest('[for]').show();
//     $(this).closest('.autocompleteaddressdiv').find('.cp').closest('[for]').show();
//     $(this).closest('.autocompleteaddressdiv').find('.city').closest('[for]').show();
//     $(this).closest('.autocompleteaddressdiv').find('.country').closest('[for]').show();
//     $(this).closest('.autocompleteaddressdiv').find('.inseeCode').closest('[for]').show();
//     // $(this).closest('.autocompleteaddressdiv').find('.lat').closest('[for]').show();
//     // $(this).closest('.autocompleteaddressdiv').find('.lng').closest('[for]').show();
// });

// $(document).on('change', '.autocompleteaddress', function () {
//     if ($(this).val() == '') return autocompleteHideError($(this).closest('.autocompleteaddressdiv'));

//     autocompleteShowError($(this).closest('.autocompleteaddressdiv'));
// })

// function autocompleteShowError(div) {
//     $(div).find('.autocompleteaddress').addClass('error');
//     $(div).find('.messagealert').show();
//     $(div).find('.messagealert').html('Veuillez sélectionner une adresse reconnue par Google (Précisez le n° et la rue)');
//     //  <b class="autocompletemanuel" style="cursor: pointer">Ou cliquez ici pour la saisir manuellement</b>
//     $(div).find('.messagealert').css({
//         color: 'red',
//     });
//     $('button,.btn-enregistrer,.validate').hide();
// }
// function autocompleteHideError(div) {
//     $(div).find('.autocompleteaddress').removeClass('error');
//     $(div).find('.messagealert').hide();
//     $('button,.btn-enregistrer,.validate').show();
// }